const LOCALES = [
  {
    name: "English",
    code: "en",
  },
  {
    name: "日本語",
    code: "ja",
  },
  {
    name: "한국어",
    code: "ko",
  },
];

export default LOCALES;
